// extracted by mini-css-extract-plugin
export default {"breadcrumb":"index_breadcrumb__2vg_i typography_bodyFont__3RHTp","breadcrumbItems":"index_breadcrumbItems__397pI","item":"index_item__2heGj","separator":"index_separator__1Z9KQ"};